var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSinsalir(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#sinsalir_svg__clip0_0_1586)",
    fill: "#122549"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.247 22.833H8.76v4.82c0 .024 0 .047-.002.071H22.25l-.002-.071v-4.82zM3.446 10.588h14.239c.43 0 .78-.35.78-.78V4.54a.78.78 0 00-.78-.78H3.446a.78.78 0 00-.78.78v5.268c0 .43.35.78.78.78zM26.127 15.479v2.463h.443v-6.328h1.983a.78.78 0 00.758-.963L28.12 5.72a.78.78 0 00-.758-.596H24.22a.78.78 0 00-.758.596l-1.193 4.93a.78.78 0 00.758.963h1.983v1.871a2.34 2.34 0 011.117 1.994z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.248 21.274v-1.18c0-1.187.965-2.152 2.15-2.152h.17V15.48a.78.78 0 00-.78-.78H7.22a.78.78 0 00-.78.78v2.463h.169c1.186 0 2.15.965 2.15 2.151v1.18h13.489zM7.2 20.092a.592.592 0 00-.591-.59H3.825a.592.592 0 00-.591.59v7.561c0 .326.265.591.59.591H6.61a.592.592 0 00.59-.591v-7.56zM27.773 27.653v-7.56a.592.592 0 00-.59-.592h-2.785a.592.592 0 00-.59.591v7.561c0 .326.265.591.59.591h2.784a.592.592 0 00.591-.591z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "sinsalir_svg__clip0_0_1586"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(2.667 2.667)",
    d: "M0 0h26.667v26.667H0z"
  })))));
}
export default SvgSinsalir;